function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './HighlighterWithRichtextHOC.css';
import React from 'react';
const highlightText = (text, searchWords) => {
  if (!searchWords.length) return text;
  const searchWordsArr = searchWords.split(" ");
  const regex = new RegExp(`(${searchWordsArr.join('|')})`, 'gi');
  const parts = text.split(regex);
  return parts.map((part, index) => regex.test(part) ? /*#__PURE__*/React.createElement("span", {
    key: index,
    className: "marked"
  }, part) : part);
};
const transformInlineStyles = cssString => {
  const stylesArray = cssString.split(';').filter(Boolean);
  const stylesObject = {};
  stylesArray.forEach(style => {
    const [property, value] = style.split(':').map(item => item.trim());
    const camelCaseProperty = property.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
    stylesObject[camelCaseProperty] = value;
  });
  return stylesObject;
};
export const HighlighterWithRichtextHOC = _ref => {
  let {
    searchWords,
    richText
  } = _ref;
  // Function to parse HTML content and separate text nodes
  const parseHTML = html => {
    const div = document.createElement('div');
    div.innerHTML = html;
    const nodes = [];
    const walk = node => {
      if (node.nodeType === Node.TEXT_NODE) {
        return {
          type: 'text',
          content: node.nodeValue
        };
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const children = Array.from(node.childNodes).map(walk);
        return {
          type: 'element',
          tag: node.tagName.toLowerCase(),
          attributes: Array.from(node.attributes).reduce((acc, attr) => {
            if (attr.name === 'style') {
              acc[attr.name] = transformInlineStyles(attr.value);
            } else {
              acc[attr.name] = attr.value;
            }
            return acc;
          }, {}),
          children
        };
      }
      return null;
    };
    div.childNodes.forEach(child => nodes.push(walk(child)));
    return nodes;
  };

  // Recursive function to render nodes with highlighted text
  const renderNodes = nodes => {
    return nodes.map((node, index) => {
      if (node.type === 'text') {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, highlightText(node.content, searchWords));
      } else if (node.type === 'element') {
        const Tag = node.tag;
        const selfClosingTags = ['br', 'img', 'input', 'hr', 'meta', 'link'];
        if (selfClosingTags.includes(node.tag)) {
          return /*#__PURE__*/React.createElement(Tag, null);
        } else {
          return /*#__PURE__*/React.createElement(Tag, _extends({
            key: index
          }, node.attributes), renderNodes(node.children));
        }
      }
      return null;
    });
  };
  const nodes = parseHTML(richText);
  return /*#__PURE__*/React.createElement("div", null, renderNodes(nodes));
};
export const commonStyles = "cvxmmrs";